var map = {
	"./template.bet575": 2154,
	"./template.bet575.tsx": 2154,
	"./template.bet777": 2155,
	"./template.bet777.tsx": 2155,
	"./template.betblast": 2156,
	"./template.betblast.tsx": 2156,
	"./template.betgalaxy": 2157,
	"./template.betgalaxy.tsx": 2157,
	"./template.betprofessor": 2158,
	"./template.betprofessor.tsx": 2158,
	"./template.betroyale": 2159,
	"./template.betroyale.tsx": 2159,
	"./template.betstride": 2160,
	"./template.betstride.tsx": 2160,
	"./template.buffalobet": 2161,
	"./template.buffalobet.tsx": 2161,
	"./template.chromabet": 2162,
	"./template.chromabet.tsx": 2162,
	"./template.default": 672,
	"./template.default.tsx": 672,
	"./template.fiestabet": 2163,
	"./template.fiestabet.tsx": 2163,
	"./template.forsport": 1624,
	"./template.forsport.tsx": 1624,
	"./template.gigabet": 2164,
	"./template.gigabet.tsx": 2164,
	"./template.goldenbet888": 2165,
	"./template.goldenbet888.tsx": 2165,
	"./template.goldenrush": 2166,
	"./template.goldenrush.tsx": 2166,
	"./template.hyperbet": 2167,
	"./template.hyperbet.tsx": 2167,
	"./template.juicybet": 2168,
	"./template.juicybet.tsx": 2168,
	"./template.junglebet": 2169,
	"./template.junglebet.tsx": 2169,
	"./template.magnumbet": 2170,
	"./template.magnumbet.tsx": 2170,
	"./template.oldgill": 2171,
	"./template.oldgill.tsx": 2171,
	"./template.puntcity": 2172,
	"./template.puntcity.tsx": 2172,
	"./template.puntgenie": 2173,
	"./template.puntgenie.tsx": 2173,
	"./template.pyramidbet": 2174,
	"./template.pyramidbet.tsx": 2174,
	"./template.questbet": 2175,
	"./template.questbet.tsx": 2175,
	"./template.slambet": 2176,
	"./template.slambet.tsx": 2176,
	"./template.sterlingparker": 2177,
	"./template.sterlingparker.tsx": 2177,
	"./template.sugarcastle": 2178,
	"./template.sugarcastle.tsx": 2178,
	"./template.templebet": 2179,
	"./template.templebet.tsx": 2179,
	"./template.titanbet": 2180,
	"./template.titanbet.tsx": 2180,
	"./template.ts": 986,
	"./template.vikingbet": 2181,
	"./template.vikingbet.tsx": 2181,
	"./template.volcanobet": 2182,
	"./template.volcanobet.tsx": 2182,
	"./template.wellbet": 2183,
	"./template.wellbet.tsx": 2183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2460;